import { useState } from "react";
import { FileText, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function QuoteForm({ booking, onSent }) {
  const [price, setPrice] = useState(booking.quoted_price || booking.service_price || "");
  const [note, setNote] = useState(booking.quote_note || "");
  const [busy, setBusy] = useState(false);
  const status = booking.quote_status;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/bookings/${booking.id}/quote`, { price: Number(price), note });
      toast.success("Quote emailed to the customer");
      onSent?.(data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send quote");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cj-card p-4 border-cyan-500/20" data-testid="quote-form">
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <FileText className="h-4 w-4 text-cyan-300" />
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">Ceramic quote</div>
        </div>
        {status && (
          <span className={`cj-pill border ${status === "accepted" ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" : status === "declined" ? "bg-red-500/10 text-red-300 border-red-500/30" : "bg-cyan-500/10 text-cyan-300 border-cyan-500/30"}`} data-testid="quote-status-badge">
            {status === "sent" ? "Awaiting customer" : status}
          </span>
        )}
      </div>
      {status === "accepted" ? (
        <div className="text-sm text-emerald-200">Accepted at <span className="font-display font-extrabold">${booking.quoted_price?.toFixed(2)}</span> — balance updated to ${booking.final_balance?.toFixed(2)}.</div>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2">
            <input type="number" min="1" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="Final price $" data-testid="quote-price-input" className="col-span-1 bg-[#0f1522] border border-white/10 rounded-lg px-3 py-2 text-slate-200 focus:outline-none focus:border-[#ff6b00]" />
            <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (paint condition, inclusions…)" data-testid="quote-note-input" className="col-span-2 bg-[#0f1522] border border-white/10 rounded-lg px-3 py-2 text-slate-200 focus:outline-none focus:border-[#ff6b00]" />
          </div>
          <button onClick={send} disabled={!price || busy} data-testid="quote-send-button" className="cj-btn-primary mt-3 w-full px-4 py-2.5 rounded-full text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} {status === "sent" || status === "declined" ? "Re-send quote" : "Email quote to customer"}
          </button>
        </>
      )}
    </div>
  );
}
